module.exports = __webpack_public_path__ + "img/SaveEnergies.32aef4da.png";